import { Switch, Route } from 'quartz-routing/react-router';
import PlaylistAssignmentsForPortal from './PlaylistAssignmentsForPortal';
import PlaylistAssignmentsPortals from './PlaylistAssignmentsPortals';
import { PLAYLIST_ASSIGNMENTS_PORTAL_URL_FRAGMENT, PLAYLIST_URL_FRAGMENT } from '../../../constants/Navigation.legacy';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PlaylistAssignmentsMonitoringRoutes = ({
  playlistId
}) => {
  return /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: PLAYLIST_ASSIGNMENTS_PORTAL_URL_FRAGMENT,
      children: /*#__PURE__*/_jsx(PlaylistAssignmentsForPortal, {
        playlistId: playlistId
      })
    }), /*#__PURE__*/_jsx(Route, {
      path: PLAYLIST_URL_FRAGMENT,
      children: /*#__PURE__*/_jsx(PlaylistAssignmentsPortals, {
        playlistId: playlistId
      })
    })]
  });
};
export default PlaylistAssignmentsMonitoringRoutes;